import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService, NB_WINDOW, NbSearchService } from '@nebular/theme';
import { filter, map } from 'rxjs/operators';
import { UserService } from '../../../@core/data/users.service';
import { AnalyticsService } from '../../../@core/utils/analytics.service';
import { LayoutService } from '../../../@core/data/layout.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { UserFormComponent } from '../../../pages/setting/settingform/userform.component';
import { User } from '../../../@core/data/model/user';

import { NbDialogService } from '@nebular/theme';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { SettingService } from '../../../@core/data/rest/setting-service';
import { FactureService } from '../../../@core/data/rest/facture/facture-service';
import { BordereauService } from '../../../@core/data/rest/bordereau/bordereau-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditFormModalComponent } from '../../../pages/facture/function/editform.modal.component';
import { plainToClass } from 'class-transformer';
import { Facture } from '../../../@core/data/model/facture';
import { PrintFormModalComponent } from '../../../pages/facture/function/printform.modal.component';
import { Commande } from '../../../@core/data/model/commande';
import { Bordereau } from '../../../@core/data/model/bordereau';
import { Reglement } from '../../../@core/data/model/reglement';





@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  @Input() position = 'normal';

  user: any;

  userMenu = [{ title: 'Mon Profile' }, { title: 'Déconnexion' }];

  constructor(
    public sidebarService: NbSidebarService,
    public menuService: NbMenuService,
    public userService: UserService,
    public analyticsService: AnalyticsService,
    public layoutService: LayoutService,
    public router: Router,
    public nbMenuService: NbMenuService,
    public authService: AuthService,
    public dialogService: NbDialogService,
    public sharedMethods: SharedMethods,
    public settingService: SettingService,
    private searchService: NbSearchService,
    public factureService: FactureService,
    public bordereauService: BordereauService,
    private modalService: NgbModal,
    ) {


  }


  ngOnInit() {
      this.userService.getUsers().subscribe((users: any) => this.user = users.paul);

      this.nbMenuService.onItemClick().pipe(
        filter(({ tag }) => tag === 'my-context-menu'),
        map(({ item: { title } }) => title),
      ).subscribe(title => this.menuClick(title));


      this.searchService.onSearchSubmit().subscribe((data: any) => {

        this.settingService.messageSearch = 'Recherche document : ' + data.term + '...';

        let  searchword: string;

        searchword = data.term;


        /* const thissetting = this.settingService;

        setTimeout(
          function(){
            thissetting.search = false;
            // alert( searchword.substr(0, 2));
            alert( searchword.substring(2) );

          },
          3000,
        ); */

        const code = searchword.substr(0, 2).toLowerCase();

        if (code === 'fc' || code === 'ff' ) {

          this.settingService.search = true;

          this.factureService.getFacture(Number(searchword.substring(2))).then( facture => {

            // console.log(facture);

            if ( facture !== null ) {

              let cmd = [];
              let bordereauxL = [];
              let bordereauxR = [];
              let reglements = [];

              this.factureService.invoiceSelected = plainToClass(Facture, facture as object);

              facture = plainToClass(Facture, Object.assign({}, facture) as object);
              cmd = plainToClass(Commande, facture.commandes);
              bordereauxL = plainToClass(Bordereau ,  facture.bordereaux_livraison);
              bordereauxR = plainToClass(Bordereau,  facture.bordereaux_retour) ;
              reglements  = plainToClass(Reglement,  facture.reglements);

              facture.commandes = [];
              facture.bordereaux_livraison = [];
              facture.bordereaux_retour = [];
              facture.reglements = [];



              const modalRef = this.modalService.open(EditFormModalComponent, { centered: true, backdrop: 'static',  size: 'lg', windowClass: 'modal-xxl' });

              modalRef.componentInstance.facture = facture;
              modalRef.componentInstance.commandes = cmd;
              modalRef.componentInstance.bordereauxL =  bordereauxL;
              modalRef.componentInstance.bordereauxR = bordereauxR;
              modalRef.componentInstance.reglements = reglements;

            } else {

              this.sharedMethods.toastShow('warning', 'Document introuvable', 'vérifiez le numéro saisir et reéssayez');
            }

            this.settingService.search = false;

          });

        } else {

          this.sharedMethods.toastShow('warning', 'Numéro invalide', 'vérifiez le numéro saisir et reéssayez');
        }


      });



  }

  menuClick(title) {

    if (title === 'Déconnexion') {

      this.goToLogin();

    }

    if (title === 'Mon Profile') {

      const user: User  = this.authService.token.user;

      // user.roles = undefined;
      // this.editUser(user, 'update');

      const closeOnBackdropClick = false;
      this.dialogService.open(UserFormComponent, {
        closeOnBackdropClick,
        context: {
          userEdit : user,
        },
      }).onClose.subscribe(data => {

          if ( data !== undefined) {

            this.sharedMethods.toastShow('success', 'Mise à jour info compte éffectué', '');

          }
      });

    }

  }



  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  toggleSettings(): boolean {

    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;

  }

  goToHome() {
    this.menuService.navigateHome();
  }

  goToLogin() {
    // this.menuService.navigateHome();
    this.authService.logout();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }

  comingsoon() {

    this.sharedMethods.toastShow('warning', 'Bientôt disponible...', '');
  }

  goToChatlink() {
    window.open('https://tawk.to/chat/5ca4bc1e6bba460528010e9d/default', '_blank');
  }

  goToHelplink() {
    window.open('https://bessalel.net/aide.php', '_blank');
  }


}
